
import React, { useState, useEffect } from 'react';
import { NAV_ITEMS } from '../constants';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'bg-white/95 dark:bg-background-dark/95 backdrop-blur-md shadow-md h-16' : 'bg-white dark:bg-background-dark h-20'} border-b border-gray-100 dark:border-gray-800`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-primary text-white w-8 h-8 rounded-lg flex items-center justify-center shadow-lg shadow-primary/20">
            <div className="w-4 h-1 bg-white rounded-full rotate-45 translate-y-[-1px]"></div>
          </div>
          <h1 className="text-xl lg:text-2xl font-black tracking-tight text-dark-gray dark:text-white uppercase">
            Margate<span className="text-primary">Roofing</span>
          </h1>
        </div>
        
        <nav className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <a 
              key={item.label}
              href={item.href} 
              className="text-sm font-semibold text-gray-600 dark:text-gray-300 hover:text-primary dark:hover:text-white transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 lg:gap-6">
          <a href="tel:5551234567" className="hidden sm:flex items-center gap-2 text-primary font-bold hover:opacity-80 transition-opacity">
            <span className="text-sm lg:text-base">(555) 123-4567</span>
          </a>
          <button className="bg-primary text-white px-5 py-2 rounded-lg font-bold text-sm hover:bg-blue-700 transition-all shadow-lg shadow-primary/20">
            Get a Quote
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
